import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const planeImg = require("./../assets/img/paper-plane.png");

const SubmittedForm = () => {
  const { state } = useLocation();

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header />

        <div className="mainContent">
          <div className="submittedDiv">
            <img src={planeImg} alt="image" />
            <p>
              Your esign form is created successfully and send to this email:{" "}
              {state?.email}
              <Link
                to={`https://cliqestimatebuilder.com/waiver_admin_app/form-preview/${state?.form_key}`}
                target="_blank"
                className="frmKey"
              >
                Form Preview
              </Link>
            </p>
            <Link to="/create-files">Back to Waiver Bill</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmittedForm;
